module.exports = __webpack_public_path__ + "static/media/eletro.da186dec.png";